module.exports = __webpack_public_path__ + "static/media/placeholder_proj.14c8ec74.jpg";